import {
  CALCULATION_ANNUAL_TAX_SEARCH_PAGE_TITLE,
  CALCULATION_CREATE_PAGE_TITLE,
  CALCULATION_LEASING_SEARCH_PAGE_TITLE,
  CALCULATION_PAGE_TITLE,
  CALCULATION_RESIDUAL_VALUE_SEARCH_PAGE_TITLE,
  CALCULATION_SEARCH_PAGE_TITLE,
  CALCULATION_SETTING_PAGE_TITLE,
  CALCULATION_TEHNICAL_INSPECTION_SEARCH_PAGE_TITLE,
  CALCULATION_TIRE_SEARCH_PAGE_TITLE,
  CALCULATION_TOLL_SEARCH_PAGE_TITLE,
  CALCULATION_VEHICLE_GROUP_SEARCH_PAGE_TITLE,
  CALCULATION_VEHICLE_INSURANCE_SEARCH_PAGE_TITLE,
  CALCULATION_VEHICLE_SERVICES_SEARCH_PAGE_TITLE,
  CONTACT_NEW_PAGE_TITLE,
  CONTACT_PAGE_TITLE,
  CONTACT_SEARCH_PAGE_TITLE,
  DASHBOARD_PAGE_TITLE,
  PRICE_LIST_SEARCH_PAGE_TITLE,
  REPORT_SEARCH_PAGE_TITLE,
  USER_NEW_PAGE_TITLE,
  USER_PAGE_TITLE,
  USER_SEARCH_PAGE_TITLE,
  FLEET_VEHICLE_NEW_PAGE_TITLE,
  FLEET_VEHICLE_PAGE_TITLE,
  FLEET_VEHICLE_SEARCH_PAGE_TITLE,
  FLEET_TIRE_SET_SEARCH_PAGE_TITLE,
  FLEET_TIRE_SET_NEW_PAGE_TITLE,
  FLEET_WAREHOUSE_SEARCH_PAGE_TITLE,
  FLEET_WAREHOUSE_CREATE_PAGE_TITLE,
  FLEET_WAREHOUSE_PAGE_TITLE,
  FLEET_TIRE_SET_PAGE_TITLE,
  FLEET_FIRE_EXTINGUISHER_SEARCH_PAGE_TITLE,
  FLEET_REGISTRATION_EXPIRY_SEARCH_PAGE_TITLE,
  FLEET_CASCO_EXPIRY_SEARCH_PAGE_TITLE,
  FLEET_TRANSFER_SEARCH_PAGE_TITLE,
  FLEET_DAMAGE_SEARCH_PAGE_TITLE,
  FLEET_DRIVER_SEARCH_PAGE_TITLE,
  FLEET_SERVICE_SEARCH_PAGE_TITLE,
  FLEET_TIRE_SEARCH_PAGE_TITLE,
  FLEET_TIRE_NEW_PAGE_TITLE,
  OFFER_SEARCH_PAGE_TITLE,
  CONTRACT_SEARCH_PAGE_TITLE,
  INVOICE_SEARCH_PAGE_TITLE,
  DOCUMENT_SEARCH_PAGE_TITLE,
  EXPENSE_SEARCH_PAGE_TITLE,
  FINANCIAL_OVERVIEW_PAGE_TITLE,
  FINANCE_PAGE_TITLE,
  INTEGRATION_PAGE_TITLE,
  MARKETPLACE_PAGE_TITLE,
  MARKETPLACE_SEARCH_PAGE_TITLE,
  SALES_PAGE_TITLE,
  SALES_INQUIRY_SEARCH_PAGE_TITLE,
  SALES_LISTING_SEARCH_PAGE_TITLE,
  NOTIFICATION_PAGE_TITLE,
  NOTIFICATION_SEARCH_PAGE_TITLE,
  NOTIFICATION_LOG_PAGE_TITLE,
  NOTIFICATION_CALENDAR_PAGE_TITLE,
  SETTING_DETAIL_PAGE_TITLE,
} from "ui/components/PageTitle/consts";
import { SidebarChildItem } from "./components/SidebarChildItem/types";
import { SidebarItem } from "./components/SidebarItem/types";

/*------------------------------------------------------------------
  DASHBOARD
-------------------------------------------------------------------*/
export const SIDEBAR_ITEM_DASHBOARD: SidebarItem = {
  text: DASHBOARD_PAGE_TITLE.text,
  icon: DASHBOARD_PAGE_TITLE.icon,
  iconColor: DASHBOARD_PAGE_TITLE.iconColor,
  route: DASHBOARD_PAGE_TITLE.route,
  childItems: undefined,
};

/*------------------------------------------------------------------
  CALCULATION
-------------------------------------------------------------------*/
export const SIDEBAR_ITEM_CALCULATION_SEARCH: SidebarChildItem = {
  text: CALCULATION_SEARCH_PAGE_TITLE.text,
  icon: CALCULATION_SEARCH_PAGE_TITLE.icon,
  iconColor: CALCULATION_SEARCH_PAGE_TITLE.iconColor,
  route: CALCULATION_SEARCH_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_CALCULATION_CREATE: SidebarChildItem = {
  text: CALCULATION_CREATE_PAGE_TITLE.text,
  icon: CALCULATION_CREATE_PAGE_TITLE.icon,
  iconColor: CALCULATION_CREATE_PAGE_TITLE.iconColor,
  route: CALCULATION_CREATE_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  CALCULATION - SETTING 
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_CALCULATION_SETTING: SidebarChildItem = {
  text: CALCULATION_SETTING_PAGE_TITLE.text,
  icon: CALCULATION_SETTING_PAGE_TITLE.icon,
  iconColor: CALCULATION_SETTING_PAGE_TITLE.iconColor,
  route: CALCULATION_SETTING_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  CALCULATION - SETTING - VEHICLE GROUP
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_CALCULATION_VEHICLE_GROUP: SidebarChildItem = {
  text: CALCULATION_VEHICLE_GROUP_SEARCH_PAGE_TITLE.text,
  icon: CALCULATION_VEHICLE_GROUP_SEARCH_PAGE_TITLE.icon,
  iconColor: CALCULATION_VEHICLE_GROUP_SEARCH_PAGE_TITLE.iconColor,
  route: CALCULATION_VEHICLE_GROUP_SEARCH_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  CALCULATION - SETTING - VEHICLE INSURANCE
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_CALCULATION_VEHICLE_INSURANCE: SidebarChildItem = {
  text: CALCULATION_VEHICLE_INSURANCE_SEARCH_PAGE_TITLE.text,
  icon: CALCULATION_VEHICLE_INSURANCE_SEARCH_PAGE_TITLE.icon,
  iconColor: CALCULATION_VEHICLE_INSURANCE_SEARCH_PAGE_TITLE.iconColor,
  route: CALCULATION_VEHICLE_INSURANCE_SEARCH_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  CALCULATION - SETTING - TOLL
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_CALCULATION_TOLL: SidebarChildItem = {
  text: CALCULATION_TOLL_SEARCH_PAGE_TITLE.text,
  icon: CALCULATION_TOLL_SEARCH_PAGE_TITLE.icon,
  iconColor: CALCULATION_TOLL_SEARCH_PAGE_TITLE.iconColor,
  route: CALCULATION_TOLL_SEARCH_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  CALCULATION - SETTING - VEHICLE SERVICE
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_CALCULATION_VEHICLE_SERVICES: SidebarChildItem = {
  text: CALCULATION_VEHICLE_SERVICES_SEARCH_PAGE_TITLE.text,
  icon: CALCULATION_VEHICLE_SERVICES_SEARCH_PAGE_TITLE.icon,
  iconColor: CALCULATION_VEHICLE_SERVICES_SEARCH_PAGE_TITLE.iconColor,
  route: CALCULATION_VEHICLE_SERVICES_SEARCH_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  CALCULATION - SETTING - LEASING
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_CALCULATION_LEASING: SidebarChildItem = {
  text: CALCULATION_LEASING_SEARCH_PAGE_TITLE.text,
  icon: CALCULATION_LEASING_SEARCH_PAGE_TITLE.icon,
  iconColor: CALCULATION_LEASING_SEARCH_PAGE_TITLE.iconColor,
  route: CALCULATION_LEASING_SEARCH_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  CALCULATION - SETTING - ANNUAL TAX
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_CALCULATION_ANNUAL_TAX: SidebarChildItem = {
  text: CALCULATION_ANNUAL_TAX_SEARCH_PAGE_TITLE.text,
  icon: CALCULATION_ANNUAL_TAX_SEARCH_PAGE_TITLE.icon,
  iconColor: CALCULATION_ANNUAL_TAX_SEARCH_PAGE_TITLE.iconColor,
  route: CALCULATION_ANNUAL_TAX_SEARCH_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  CALCULATION - SETTING - TEHNICAL INSPECTION
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_CALCULATION_TEHNICAL_INSPECTION: SidebarChildItem = {
  text: CALCULATION_TEHNICAL_INSPECTION_SEARCH_PAGE_TITLE.text,
  icon: CALCULATION_TEHNICAL_INSPECTION_SEARCH_PAGE_TITLE.icon,
  iconColor: CALCULATION_TEHNICAL_INSPECTION_SEARCH_PAGE_TITLE.iconColor,
  route: CALCULATION_TEHNICAL_INSPECTION_SEARCH_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  CALCULATION - SETTING - TIRE
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_CALCULATION_TIRE: SidebarChildItem = {
  text: CALCULATION_TIRE_SEARCH_PAGE_TITLE.text,
  icon: CALCULATION_TIRE_SEARCH_PAGE_TITLE.icon,
  iconColor: CALCULATION_TIRE_SEARCH_PAGE_TITLE.iconColor,
  route: CALCULATION_TIRE_SEARCH_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  CALCULATION - SETTING - RESIDUAL VALUE
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_CALCULATION_RESIDUAL_VALUE: SidebarChildItem = {
  text: CALCULATION_RESIDUAL_VALUE_SEARCH_PAGE_TITLE.text,
  icon: CALCULATION_RESIDUAL_VALUE_SEARCH_PAGE_TITLE.icon,
  iconColor: CALCULATION_RESIDUAL_VALUE_SEARCH_PAGE_TITLE.iconColor,
  route: CALCULATION_RESIDUAL_VALUE_SEARCH_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  SETTING - VEHICLE GROUP
-------------------------------------------------------------------*/

// export const SIDEBAR_ITEM_CALCULATION: SidebarItem = {
//   text: CALCULATION_PAGE_TITLE.text,
//   icon: CALCULATION_PAGE_TITLE.icon,
//   route: CALCULATION_PAGE_TITLE.route,
//   childItems: [
//     SIDEBAR_ITEM_CALCULATION_SEARCH,
//     SIDEBAR_ITEM_CALCULATION_CREATE,
//     SIDEBAR_ITEM_CALCULATION_SETTING,
//   ],
// };
/*------------------------------------------------------------------
  USER
-------------------------------------------------------------------*/
export const SIDEBAR_ITEM_USERS_SEARCH: SidebarChildItem = {
  text: USER_SEARCH_PAGE_TITLE.text,
  icon: USER_SEARCH_PAGE_TITLE.icon,
  iconColor: USER_SEARCH_PAGE_TITLE.iconColor,
  route: USER_SEARCH_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_USER_NEW: SidebarChildItem = {
  text: USER_NEW_PAGE_TITLE.text,
  icon: USER_NEW_PAGE_TITLE.icon,
  iconColor: USER_NEW_PAGE_TITLE.iconColor,
  route: USER_NEW_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_USER: SidebarItem = {
  text: USER_PAGE_TITLE.text,
  icon: USER_PAGE_TITLE.icon,
  route: USER_PAGE_TITLE.route,
  childItems: [SIDEBAR_ITEM_USERS_SEARCH],
};

/*------------------------------------------------------------------
  FLEET - TIRE SET 
-------------------------------------------------------------------*/
export const SIDEBAR_ITEM_FLEET_TIRE_SET_SEARCH: SidebarChildItem = {
  text: FLEET_TIRE_SET_SEARCH_PAGE_TITLE.text,
  icon: FLEET_TIRE_SET_SEARCH_PAGE_TITLE.icon,
  iconColor: FLEET_TIRE_SET_SEARCH_PAGE_TITLE.iconColor,
  route: FLEET_TIRE_SET_SEARCH_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_FLEET_TIRE_SET_NEW: SidebarChildItem = {
  text: FLEET_TIRE_SET_NEW_PAGE_TITLE.text,
  icon: FLEET_TIRE_SET_NEW_PAGE_TITLE.icon,
  iconColor: FLEET_TIRE_SET_NEW_PAGE_TITLE.iconColor,
  route: FLEET_TIRE_SET_NEW_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  FLEET - TIRE  
-------------------------------------------------------------------*/
export const SIDEBAR_ITEM_FLEET_TIRE_SEARCH: SidebarChildItem = {
  text: FLEET_TIRE_SEARCH_PAGE_TITLE.text,
  icon: FLEET_TIRE_SEARCH_PAGE_TITLE.icon,
  iconColor: FLEET_TIRE_SEARCH_PAGE_TITLE.iconColor,
  route: FLEET_TIRE_SEARCH_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_FLEET_TIRE_NEW: SidebarChildItem = {
  text: FLEET_TIRE_NEW_PAGE_TITLE.text,
  icon: FLEET_TIRE_NEW_PAGE_TITLE.icon,
  iconColor: FLEET_TIRE_NEW_PAGE_TITLE.iconColor,
  route: FLEET_TIRE_NEW_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  FLEET - WAREHOUSE
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_FLEET_WAREHOUSE_SEARCH: SidebarChildItem = {
  text: FLEET_WAREHOUSE_SEARCH_PAGE_TITLE.text,
  icon: FLEET_WAREHOUSE_SEARCH_PAGE_TITLE.icon,
  iconColor: FLEET_WAREHOUSE_SEARCH_PAGE_TITLE.iconColor,
  route: FLEET_WAREHOUSE_SEARCH_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_FLEET_WAREHOUSE_NEW: SidebarChildItem = {
  text: FLEET_WAREHOUSE_CREATE_PAGE_TITLE.text,
  icon: FLEET_WAREHOUSE_CREATE_PAGE_TITLE.icon,
  iconColor: FLEET_WAREHOUSE_CREATE_PAGE_TITLE.iconColor,
  route: FLEET_WAREHOUSE_CREATE_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  FLEET - VEHICLES
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_FLEET_VEHICLE_SEARCH: SidebarChildItem = {
  text: FLEET_VEHICLE_SEARCH_PAGE_TITLE.text,
  icon: FLEET_VEHICLE_SEARCH_PAGE_TITLE.icon,
  iconColor: FLEET_VEHICLE_SEARCH_PAGE_TITLE.iconColor,
  route: FLEET_VEHICLE_SEARCH_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_FLEET_VEHICLE_NEW: SidebarChildItem = {
  text: FLEET_VEHICLE_NEW_PAGE_TITLE.text,
  icon: FLEET_VEHICLE_NEW_PAGE_TITLE.icon,
  iconColor: FLEET_VEHICLE_NEW_PAGE_TITLE.iconColor,
  route: FLEET_VEHICLE_NEW_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_FLEET_VEHICLE: SidebarItem = {
  text: FLEET_VEHICLE_PAGE_TITLE.text,
  icon: FLEET_VEHICLE_PAGE_TITLE.icon,
  route: FLEET_VEHICLE_PAGE_TITLE.route,
  childItems: [
    FLEET_VEHICLE_PAGE_TITLE,
    FLEET_TIRE_SET_PAGE_TITLE,
    FLEET_WAREHOUSE_PAGE_TITLE,
    FLEET_FIRE_EXTINGUISHER_SEARCH_PAGE_TITLE,
    FLEET_TRANSFER_SEARCH_PAGE_TITLE,
    FLEET_DAMAGE_SEARCH_PAGE_TITLE,
    FLEET_SERVICE_SEARCH_PAGE_TITLE,
    FLEET_DRIVER_SEARCH_PAGE_TITLE,
    { ...FLEET_REGISTRATION_EXPIRY_SEARCH_PAGE_TITLE, text: "Registracija" },
    FLEET_CASCO_EXPIRY_SEARCH_PAGE_TITLE,
    // SIDEBAR_ITEM_CALCULATION_SEARCH,
  ],
};

/*------------------------------------------------------------------
  CONTACTS
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_CONTACT_SEARCH: SidebarChildItem = {
  text: CONTACT_SEARCH_PAGE_TITLE.text,
  icon: CONTACT_SEARCH_PAGE_TITLE.icon,
  iconColor: CONTACT_SEARCH_PAGE_TITLE.iconColor,
  route: CONTACT_SEARCH_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_CONTACT_NEW: SidebarChildItem = {
  text: CONTACT_NEW_PAGE_TITLE.text,
  icon: CONTACT_NEW_PAGE_TITLE.icon,
  iconColor: CONTACT_NEW_PAGE_TITLE.iconColor,
  route: CONTACT_NEW_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_CONTACT: SidebarItem = {
  text: CONTACT_PAGE_TITLE.text,
  icon: CONTACT_PAGE_TITLE.icon,
  route: CONTACT_PAGE_TITLE.route,
  childItems: [CONTACT_SEARCH_PAGE_TITLE],
};

/*------------------------------------------------------------------
  OFFER
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_OFFER_SEARCH: SidebarChildItem = {
  text: OFFER_SEARCH_PAGE_TITLE.text,
  icon: OFFER_SEARCH_PAGE_TITLE.icon,
  iconColor: OFFER_SEARCH_PAGE_TITLE.iconColor,
  route: OFFER_SEARCH_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  CONTRACT
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_CONTRACT_SEARCH: SidebarChildItem = {
  text: CONTRACT_SEARCH_PAGE_TITLE.text,
  icon: CONTRACT_SEARCH_PAGE_TITLE.icon,
  iconColor: CONTRACT_SEARCH_PAGE_TITLE.iconColor,
  route: CONTRACT_SEARCH_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  INVOICE
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_INVOICE_SEARCH: SidebarChildItem = {
  text: INVOICE_SEARCH_PAGE_TITLE.text,
  icon: INVOICE_SEARCH_PAGE_TITLE.icon,
  iconColor: INVOICE_SEARCH_PAGE_TITLE.iconColor,
  route: INVOICE_SEARCH_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  DOCUMENT (Finance > Dokumenti — global view)
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_DOCUMENT_SEARCH: SidebarChildItem = {
  text: DOCUMENT_SEARCH_PAGE_TITLE.text,
  icon: DOCUMENT_SEARCH_PAGE_TITLE.icon,
  iconColor: DOCUMENT_SEARCH_PAGE_TITLE.iconColor,
  route: DOCUMENT_SEARCH_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  EXPENSE (Finance > Troškovi — global view)
-------------------------------------------------------------------*/

export const SIDEBAR_ITEM_EXPENSE_SEARCH: SidebarChildItem = {
  text: EXPENSE_SEARCH_PAGE_TITLE.text,
  icon: EXPENSE_SEARCH_PAGE_TITLE.icon,
  iconColor: EXPENSE_SEARCH_PAGE_TITLE.iconColor,
  route: EXPENSE_SEARCH_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_FINANCIAL_OVERVIEW: SidebarChildItem = {
  text: FINANCIAL_OVERVIEW_PAGE_TITLE.text,
  icon: FINANCIAL_OVERVIEW_PAGE_TITLE.icon,
  iconColor: FINANCIAL_OVERVIEW_PAGE_TITLE.iconColor,
  route: FINANCIAL_OVERVIEW_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_FINANCE: SidebarItem = {
  text: FINANCE_PAGE_TITLE.text,
  icon: FINANCE_PAGE_TITLE.icon,
  route: FINANCE_PAGE_TITLE.route,
  childItems: [SIDEBAR_ITEM_OFFER_SEARCH, SIDEBAR_ITEM_CONTRACT_SEARCH, SIDEBAR_ITEM_INVOICE_SEARCH, SIDEBAR_ITEM_EXPENSE_SEARCH, SIDEBAR_ITEM_DOCUMENT_SEARCH],
};


/*------------------------------------------------------------------
  PRICES
-------------------------------------------------------------------*/
export const SIDEBAR_ITEM_PRICE: SidebarItem = {
  text: PRICE_LIST_SEARCH_PAGE_TITLE.text,
  icon: PRICE_LIST_SEARCH_PAGE_TITLE.icon,
  route: PRICE_LIST_SEARCH_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  SETTINGS
-------------------------------------------------------------------*/
// Platformski ekrani (nadzorna ploca, tenanti, prijevodi, postavke aplikacije) preselili su se
// u `admin.autobiz`, pa zupcanika u sidebaru vise nema. Postavke tenanta se otvaraju preko
// korisnickog izbornika gore desno ("Postavke tvrtke").
//
// Ovo ostaje samo kao korijen za breadcrumb na tim stranicama.
export const SIDEBAR_ITEM_SETTING: SidebarItem = {
  text: SETTING_DETAIL_PAGE_TITLE.text,
  icon: SETTING_DETAIL_PAGE_TITLE.icon,
  route: SETTING_DETAIL_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  REPORTS
-------------------------------------------------------------------*/
export const SIDEBAR_ITEM_REPORT_SEARCH: SidebarChildItem = {
  text: REPORT_SEARCH_PAGE_TITLE.text,
  icon: REPORT_SEARCH_PAGE_TITLE.icon,
  iconColor: REPORT_SEARCH_PAGE_TITLE.iconColor,
  route: REPORT_SEARCH_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_REPORT: SidebarItem = {
  text: REPORT_SEARCH_PAGE_TITLE.text,
  icon: REPORT_SEARCH_PAGE_TITLE.icon,
  route: REPORT_SEARCH_PAGE_TITLE.route,
  // Financijski pregled je izvještaj, ne dnevni rad s financijama — zato stoji ovdje,
  // a ne pod Financijama.
  childItems: [SIDEBAR_ITEM_REPORT_SEARCH, SIDEBAR_ITEM_FINANCIAL_OVERVIEW],
};

/*------------------------------------------------------------------
  INTEGRATIONS
-------------------------------------------------------------------*/
export const SIDEBAR_ITEM_INTEGRATION: SidebarItem = {
  text: INTEGRATION_PAGE_TITLE.text,
  icon: INTEGRATION_PAGE_TITLE.icon,
  route: INTEGRATION_PAGE_TITLE.route,
  childItems: [],
};

/*------------------------------------------------------------------
  MARKETPLACE
-------------------------------------------------------------------*/
/*------------------------------------------------------------------
  NOTIFICATIONS
-------------------------------------------------------------------*/
export const SIDEBAR_ITEM_NOTIFICATION_SEARCH: SidebarChildItem = {
  text: NOTIFICATION_SEARCH_PAGE_TITLE.text,
  icon: NOTIFICATION_SEARCH_PAGE_TITLE.icon,
  iconColor: NOTIFICATION_SEARCH_PAGE_TITLE.iconColor,
  route: NOTIFICATION_SEARCH_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_NOTIFICATION_LOG: SidebarChildItem = {
  text: NOTIFICATION_LOG_PAGE_TITLE.text,
  icon: NOTIFICATION_LOG_PAGE_TITLE.icon,
  iconColor: NOTIFICATION_LOG_PAGE_TITLE.iconColor,
  route: NOTIFICATION_LOG_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_NOTIFICATION_CALENDAR: SidebarChildItem = {
  text: NOTIFICATION_CALENDAR_PAGE_TITLE.text,
  icon: NOTIFICATION_CALENDAR_PAGE_TITLE.icon,
  iconColor: NOTIFICATION_CALENDAR_PAGE_TITLE.iconColor,
  route: NOTIFICATION_CALENDAR_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_NOTIFICATION: SidebarItem = {
  text: NOTIFICATION_PAGE_TITLE.text,
  icon: NOTIFICATION_PAGE_TITLE.icon,
  route: NOTIFICATION_PAGE_TITLE.route,
  childItems: [
    SIDEBAR_ITEM_NOTIFICATION_SEARCH,
    SIDEBAR_ITEM_NOTIFICATION_LOG,
    SIDEBAR_ITEM_NOTIFICATION_CALENDAR,
  ],
};

/*------------------------------------------------------------------
  SALES (PRODAJA)
-------------------------------------------------------------------*/
export const SIDEBAR_ITEM_SALES_INQUIRY_SEARCH: SidebarChildItem = {
  text: SALES_INQUIRY_SEARCH_PAGE_TITLE.text,
  icon: SALES_INQUIRY_SEARCH_PAGE_TITLE.icon,
  iconColor: SALES_INQUIRY_SEARCH_PAGE_TITLE.iconColor,
  route: SALES_INQUIRY_SEARCH_PAGE_TITLE.route,
};



export const SIDEBAR_ITEM_SALES_LISTING_SEARCH: SidebarChildItem = {
  text: SALES_LISTING_SEARCH_PAGE_TITLE.text,
  icon: SALES_LISTING_SEARCH_PAGE_TITLE.icon,
  iconColor: SALES_LISTING_SEARCH_PAGE_TITLE.iconColor,
  route: SALES_LISTING_SEARCH_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_SALES: SidebarItem = {
  text: SALES_PAGE_TITLE.text,
  icon: SALES_PAGE_TITLE.icon,
  route: SALES_PAGE_TITLE.route,
  childItems: [
    // Ista ruta kao `SALES_LISTING_PAGE_TITLE`, ali natpis „Vozila za prodaju" — isti kao naslov
    // stranice na koju vodi.
    SIDEBAR_ITEM_SALES_LISTING_SEARCH,
    // SIDEBAR_ITEM_SALES_INQUIRY_SEARCH,
  ],
};

/*------------------------------------------------------------------
  MARKETPLACE
-------------------------------------------------------------------*/
export const SIDEBAR_ITEM_MARKETPLACE_SEARCH: SidebarChildItem = {
  text: MARKETPLACE_SEARCH_PAGE_TITLE.text,
  icon: MARKETPLACE_SEARCH_PAGE_TITLE.icon,
  iconColor: MARKETPLACE_SEARCH_PAGE_TITLE.iconColor,
  route: MARKETPLACE_SEARCH_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_MARKETPLACE: SidebarItem = {
  text: MARKETPLACE_PAGE_TITLE.text,
  icon: MARKETPLACE_PAGE_TITLE.icon,
  route: MARKETPLACE_PAGE_TITLE.route,
  childItems: [MARKETPLACE_SEARCH_PAGE_TITLE],
};

/*------------------------------------------------------------------
  RESULT
-------------------------------------------------------------------*/
export const SIDEBAR_ITEMS = [
  SIDEBAR_ITEM_DASHBOARD,
  // SIDEBAR_ITEM_CALCULATION,
  SIDEBAR_ITEM_FLEET_VEHICLE,

  SIDEBAR_ITEM_SALES,
  SIDEBAR_ITEM_MARKETPLACE,
  SIDEBAR_ITEM_FINANCE,
  SIDEBAR_ITEM_CONTACT,

  SIDEBAR_ITEM_USER,
  // SIDEBAR_ITEM_PRICE,
  SIDEBAR_ITEM_INTEGRATION,
  SIDEBAR_ITEM_NOTIFICATION,
  SIDEBAR_ITEM_REPORT,
];
